import styled from 'styled-components'

export const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #ffffff;
  margin: 0 !important;
  padding: 0 !important;
  width: 100%;
  max-width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
`

export const HeaderAspaec = styled.header`
  background: linear-gradient(135deg, #02B0BB 0%, #0199A8 100%);
  padding: 25px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 100%;

  img {
    height: 70px;
    width: auto;
  }

  @media (max-width: 768px) {
    padding: 20px 0;

    img {
      height: 50px;
    }
  }
`

export const MainContent = styled.main`
  flex: 1;
  display: flex;
  width: 100%;
  padding: 60px 80px;
  gap: 80px;
  background: #ffffff;

  @media (max-width: 968px) {
    flex-direction: column;
    padding: 40px 20px;
    gap: 40px;
  }
`

export const LoginBox = styled.div`
  flex: 1;
  background: #ffffff;
  padding: 20px;

  h2 {
    font-size: 28px;
    font-weight: 700;
    color: #1a1a1a;
    margin-bottom: 40px;
    font-family: 'Poppins', sans-serif;
  }

  @media (max-width: 968px) {
    padding: 20px;
  }
`

export const ContactBox = styled.div`
  flex: 1;
  background: #F5F5F5;
  padding: 40px;
  border-radius: 8px;

  h3 {
    font-size: 28px;
    font-weight: 700;
    color: #1a1a1a;
    margin-bottom: 16px;
    font-family: 'Poppins', sans-serif;
  }

  p {
    font-size: 15px;
    color: #666666;
    margin-bottom: 40px;
    line-height: 1.6;
  }

  @media (max-width: 968px) {
    padding: 30px 20px;
  }
`

export const ContactItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 24px;

  img {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
  }

  div {
    flex: 1;

    strong {
      display: block;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      margin-bottom: 4px;
    }

    p {
      margin: 0;
      font-size: 14px;
      color: #666666;
    }

    a {
      color: #02B0BB;
      text-decoration: none;
      font-size: 16px;
      font-weight: 500;

      &:hover {
        text-decoration: underline;
      }
    }
  }
`

export const LoginForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const InputGroup = styled.div`
  position: relative;
  margin-bottom: 20px;

  input {
    width: 100%;
    padding: 14px 18px;
    border: 1px solid #D1D5DB;
    border-radius: 6px;
    font-size: 15px;
    color: #1F2937;
    font-family: 'Poppins', sans-serif;
    transition: all 0.2s;
    background: #FFFFFF;

    &:focus {
      outline: none;
      border-color: #02B0BB;
      box-shadow: 0 0 0 3px rgba(2, 176, 187, 0.1);
    }

    &::placeholder {
      color: #9CA3AF;
    }
  }

  .toggle-password {
    position: absolute;
    right: 14px;
    top: 50%;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 18px;
    padding: 4px;
    color: #6B7280;
    transition: color 0.2s;

    &:hover {
      color: #02B0BB;
    }
  }
`

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;

  label {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    font-size: 14px;
    color: #4B5563;

    input[type='checkbox'] {
      width: 18px;
      height: 18px;
      cursor: pointer;
      accent-color: #02B0BB;
    }

    span {
      user-select: none;
    }
  }
`

export const ForgotPasswordLink = styled.button`
  background: transparent;
  border: none;
  color: #02B0BB;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  text-align: left;
  padding: 0;
  margin-bottom: 24px;
  text-decoration: none;
  font-family: 'Poppins', sans-serif;

  &:hover {
    text-decoration: underline;
  }
`

export const LoginButton = styled.button`
  width: 100%;
  padding: 16px 24px;
  background: #1F2937;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  font-family: 'Poppins', sans-serif;
  transition: all 0.2s;
  margin-bottom: 16px;
  letter-spacing: 0.5px;

  &:hover {
    background: #111827;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0);
  }
`

export const RegisterLink = styled.div`
  text-align: center;
  font-size: 14px;
  margin-top: 8px;

  button {
    background: transparent;
    border: none;
    color: #02B0BB;
    font-weight: 600;
    cursor: pointer;
    padding: 0;
    text-decoration: none;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;

    &:hover {
      text-decoration: underline;
    }
  }
`

export const Footer = styled.footer`
  background: #F9FAFB;
  padding: 24px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #E5E7EB;

  a {
    color: #02B0BB;
    text-decoration: none;
    font-size: 14px;
    font-family: 'Poppins', sans-serif;
    transition: color 0.2s;

    &:hover {
      text-decoration: underline;
    }
  }

  div {
    display: flex;
    align-items: center;
    gap: 8px;

    img {
      height: 24px;
      width: auto;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
    text-align: center;
    padding: 24px 20px;
  }
`
